// extracted by css-extract-rspack-plugin
export default {"date":"PublishedDate-module__date__HamGF"};